import { Menu } from "antd";
import React from "react";
import useSidebarMenuItems from "./useSidebarMenuItems";

const SidebarMenu = () => {
  const { menuItems } = useSidebarMenuItems();
  const selectedKey = menuItems
    ?.flatMap(m => m?.children)
    ?.find(c => c?.orden);

  return (
    <Menu
      items={menuItems}
      mode="inline"
      selectedKeys={selectedKey}
      style={{ height: "100%" }}
    />
  )
};

export default React.memo(SidebarMenu);